import { render, staticRenderFns } from "./tiscModal.vue?vue&type=template&id=620ad4ec&scoped=true&"
import script from "./tiscModal.vue?vue&type=script&lang=js&"
export * from "./tiscModal.vue?vue&type=script&lang=js&"
import style0 from "./tiscModal.vue?vue&type=style&index=0&id=620ad4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ad4ec",
  null
  
)

export default component.exports